import React, { useEffect, useState, useRef } from "react";
import BannerSection from "../../components/BannerSection";
import Page from "../../components/Page";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import ShimmerNotification from "../../components/Layouts/ShimmerNotification";
import VideoCatLeftMenu from "../../components/Video/VideoCatLeftMenu";
import ShimmerCardBodyThree from "../../components/Layouts/ShimmerCardBodyThree";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getVideoCoursesListingByCat,
  getVideoCoursesListingBySubCat,
} from "../../redux/video/actions";
import { SessionKeys, clickStreamUser } from "../../utils/AppUtils";
import VideoCoursesListingCard from "../videoCourses/VideoCoursListingCard";
import { providerDetails } from "../../redux/provider/actions";
import { useTranslation } from "react-i18next";
const FILTER_BY = [
  { id: 1, value: "All" },
  { id: 2, value: "Available For Purchase" },
  { id: 3, value: "Purchased Videos" },
  { id: 4, value: "Assigned To Me" },
];
const SORT_BY = [
  { id: 1, value: "New to Old" },
  { id: 2, value: "Old to New" },
];

const Provider = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { state } = location;
  console.log("state.props", state);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const catId = params.get("catId");
  const _searchRef = useRef(null);

  const [subCategories, setSubCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [innerCategoryName, setInnerCategoryName] = useState("");
  const [coursesList, setCoursesList] = useState([]);

  const [isOwnCategoryClick, setIsOwnCategoryClick] = useState(false);

  const [filterBy, setFilterBy] = useState(FILTER_BY[0].id);
  const [sortBy, setSortBy] = useState(SORT_BY[0].id);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [filterList, setFilterList] = useState([]);

  const authBroker = useSelector((state) => state.auth.authBroker);

  const getCategoryVideos = () => {
    setFilterBy(FILTER_BY[0].id);
    setSortBy(SORT_BY[0].id);
    setIsLoading(true);
    dispatch(
      getVideoCoursesListingByCat({
        module: "getVideoCourseListingByCat",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          brokerage_id: authBroker.payload.user.company_id,
          category_id: catId,
        },
      }),
    );
  };

  useEffect(() => {
    dispatch(
      providerDetails({
        postData: {
          provider_id: "62b9a63fec25cc099e5ac044",
          entity_type: "get_provider_details",
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      }),
    );
  }, []);

  const getSubCategoryVideos = (subCatId) => {
    setFilterBy(FILTER_BY[0].id);
    setSortBy(SORT_BY[0].id);
    setIsLoading(true);
    dispatch(
      getVideoCoursesListingBySubCat({
        module: "getVideoCourseListingBySubCat",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          brokerage_id: authBroker.payload.user.company_id,
          sub_category_id: subCatId,
        },
      }),
    );
  };

  //Sorting Video listing
  const sortByAlphabetical = (list) => {
    // console.log(
    //   "sortingggg1--->",
    //   list.sort((a, b) => a.published_date.localeCompare(b.published_date))
    // );
    return _.reverse(_.sortBy(list, "updated_dt"));
  };

  const sortByAlphabeticalReverse = (list) => {
    // console.log(
    //   "sortingggg1--->",
    //   list.sort((a, b) => a.published_date.localeCompare(b.published_date))
    // );
    return _.sortBy(list, "updated_dt");
  };
  const sortByAlphabeticalDes = (list) => {
    return list.filter((item) => item.is_purchased);
  };

  const onClickFilterBy = (e) => {
    const value = e.target.value;
    setFilterBy(value);
    // console.log("FILTER BY", value);
    if (value === 1) {
      // const sortedList = sortByAlphabetical(actualCoursesList);
      setCoursesList(actualCoursesList);
      setFilterList(actualCoursesList);
      clickStreamUser("clicked-All-View", {
        userId: authBroker?.payload?.user.user_id,
      });
    } else if (value === 2) {
      const filtered = actualCoursesList.filter((c) => c.showBuy);
      setCoursesList(filtered);
      clickStreamUser("clicked-available-for-purchase", {
        userId: authBroker?.payload?.user.user_id,
      });
    } else if (value === 3) {
      const sortedListbyDes = sortByAlphabeticalDes(actualCoursesList);
      setCoursesList(sortedListbyDes);
      clickStreamUser("clicked-purchased-list", {
        userId: authBroker?.payload?.user.user_id,
      });
    } else if (value === 4) {
      const sortedData = actualCoursesList.filter(
        (c) => c.is_assigned && !c.is_purchased,
      );
      setCoursesList(sortedData);
      clickStreamUser("clicked-assign-to-me-filter", {
        userId: authBroker?.payload?.user.user_id,
      });
    }
    setSortBy(1);
    _searchRef.current.value = "";
  };

  const onClickSortBy = (e) => {
    const value = e.target.value;
    setSortBy(value);
    console.log("SORT BY", value);
    if (value === 1) {
      const sortedList = sortByAlphabetical(coursesList);
      setCoursesList(sortedList);
      setFilterList(sortedList);
      clickStreamUser("clicked-New-to-Old", {
        userId: authBroker?.payload?.user.user_id,
      });
    } else if (value === 2) {
      const sortedListbyDes = sortByAlphabeticalReverse(coursesList);
      console.log(sortedListbyDes);
      setCoursesList(sortedListbyDes);
      setFilterList(sortedListbyDes);
      clickStreamUser("clicked-Old-to-New", {
        userId: authBroker?.payload?.user.user_id,
      });
    }
  };

  const { provider_name } = props;
  return (
    <>
      <Loader start={isLoading} />
      <Page>
        <section className="bannermodule">
          <BannerSection isLoading={isLoading} setIsLoading={setIsLoading} />
        </section>

        <div className="my-credit-points video-page-rsp">
          <section className="container">
            <div className="row">
              <div className="col-md-12 profile-left-sec">
                <div className="search_heading">
                  <p className="lable-heading_search">
                    Coaching By {state?.provider_name}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-3 search__input">
                <div className="input-lear position-relative reg-select">
                  <label htmlFor="category" className="input__label">
                    Category
                  </label>
                  <select
                    className="form-select input_searchfield"
                    id="category"
                    aria-label="Default select example"
                  >
                    <option>1</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 search__input">
                <div className="input-lear position-relative d-flex">
                  <label htmlFor="sortBy" className="input__label">
                    {t("filter_by")}
                  </label>
                  <select
                    className={`form-select input_searchfield ${isLoading ? "not-allowed" : ""}`}
                    aria-label="Default select example"
                    value={filterBy}
                    onChange={onClickFilterBy}
                  >
                    {FILTER_BY.map((item, index) => {
                      return (
                        <option
                          selected={filterBy === item?.id ? true : false}
                          key={index}
                          value={item.id}
                        >
                          {item.value}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-3 search__input">
                <div className="input-lear position-relative d-flex">
                  <label htmlFor="sortBy" className="input__label">
                    Sort by
                  </label>
                  <select
                    className={`form-select input_searchfield ${isLoading ? "not-allowed" : ""}`}
                    aria-label="Default select example"
                    value={sortBy}
                    onChange={onClickSortBy}
                  >
                    {SORT_BY.map((item, index) => {
                      return (
                        <option
                          selected={sortBy === item?.id ? true : false}
                          key={index}
                          value={item.id}
                        >
                          {item.value}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="col-md-3 search__input">
                <div className="input-lear position-relative d-flex">
                  <label htmlFor="search" className="input__label">
                    Search
                  </label>
                  <input
                    type="text"
                    id="search"
                    name="search"
                    className={`input_searchfield_search ${isLoading ? "not-allowed" : ""}`}
                  />
                  <button
                    className={`button-reset ${isLoading ? "not-allowed" : ""}`}
                    style={{ marginTop: "-20px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="Find"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradient"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stopColor="#415385" />
                          <stop offset="1" stopColor="#415385" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_191"
                        data-name="Ellipse 191"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradient)"
                      />
                      <circle
                        id="Ellipse_192"
                        data-name="Ellipse 192"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                      />
                      <path
                        id="Icon_awesome-search"
                        data-name="Icon awesome-search"
                        d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                        transform="translate(7.715 7.714)"
                        fill="#415385"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-3">
                {true ? (
                  <VideoCatLeftMenu
                    subCategories={subCategories}
                    categoryName={categoryName}
                    getSubCategoryVideos={getSubCategoryVideos}
                    setIsOwnCategoryClick={setIsOwnCategoryClick}
                    getCategoryVideos={getCategoryVideos}
                    isLoading={isLoading}
                  />
                ) : (
                  <>
                    <div className="row">
                      {[1, 2].map((n) => {
                        return <ShimmerNotification />;
                      })}
                    </div>
                  </>
                )}
              </div>
              <div className="col-md-9">
                {!isLoading ? (
                  <VideoCoursesListingCard
                    innerCategoryName={innerCategoryName}
                    coursesList={coursesList}
                    isLoading={isLoading}
                    isProviderListing={true}
                  />
                ) : (
                  <>
                    <div className="row videolistbox">
                      {[1, 2, 3].map((i) => {
                        return <ShimmerCardBodyThree key={`shimmer-${i}`} />;
                      })}
                    </div>
                  </>
                )}
              </div>
            </div>
          </section>
        </div>
      </Page>
    </>
  );
};

export default Provider;
